import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { required, email, regex } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
setInteractionMode("eager")

import { mapGetters } from 'vuex';

const reporte = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        paises: [],
        internos: [],
        clientes: [],
        minutas: [],
        form: {
            campana: null,
            centro: null,
            segmento: null,
            pais: null,
            dateStart: null,
            dateEnd: null,
            selectedAttendee: null,
            export: false
        },
        headerMinuta: [
            { text: 'Pais', value: 'pais',  style: 'background-color: #008000' },
            { text: 'Sede', value: 'centro',  style: 'background-color: #008000' },
            { text: 'Segmento', value: 'segmento',  style: 'background-color: #008000' },
            { text: 'Campanaña', value: 'campana',  style: 'background-color: #008000' },
            { text: 'Nombre Reunion', value: 'nombre_evento',  style: 'background-color: #008000' },
            { text: 'Nombre Minuta', value: 'nombre_minuta',  style: 'background-color: #008000' },
            { text: 'Participantes', value: 'participantes',  style: 'background-color: #008000' },
            { text: 'Creador', value: 'creador_minuta',  style: 'background-color: #008000' },
            { text: 'Fecha Creacion Minuta', value: 'fecha_creacion_minuta',  style: 'background-color: #008000' },
            { text: 'Fecha Cierre Minuta', value: 'fecha_cierre_minuta',  style: 'background-color: #008000' },
            { text: 'Estado', value: 'estado_minuta',  style: 'background-color: #008000' },
        ],
        loadingMinutas: false,
        loadingBtnExport: false,
        loadingBtnFilter: false,
        dialogFiltros: false,
        fechaStartStatus: false,
        fechaEndStatus: false,
        selectedMeetingType: null,
        meetingTypes: [
            { text: 'Interno', value: 'interno' },
            { text: 'Cliente', value: 'cliente' }
        ],
        selectedAttendee: null,
        dialogParticipantes: false,
        listaParticipantes: null,
    }),
    mounted() {
        this.fechasFiltros();
        this.createEvent();
        // this.fetchInternos();
        // this.fetchClients();
    },
    computed: {
        ...mapGetters(['getPaises', 'getCentros', 'getSegmentos', 'getCampanas']),
        filteredCentros() {
            return this.getCentros.filter(centro => centro.inPaisId === this.form.pais).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredSegmentos() {
            let segmentos = []
            let uniqueSegmento = []

            if (Array.isArray(this.form.centro) && this.form.centro.length > 0) {
                segmentos = this.getCampanas.filter(item => this.form.centro.includes(item.in_CentroId)).map(item => item.in_SegmentoId);
                uniqueSegmento = [...new Set(segmentos)];
            }
            return this.getSegmentos.filter(item => uniqueSegmento.includes(item.Id)).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredCampanas() {
            let campanas = [];

            if (Array.isArray(this.form.segmento) && this.form.segmento.length > 0) {
                campanas = this.getCampanas.
                    filter(item => this.form.centro.includes(item.in_CentroId)).
                    filter(item => this.form.segmento.includes(item.in_SegmentoId));
            }
            return campanas.sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        formattedConvocados() {
            return this.filteredConvocados().map(convocado => {
                return {
                    ...convocado,
                    fullName: `${convocado.vc_Nombres} ${convocado.vc_ApePaterno} ${convocado.vc_ApeMaterno}(${convocado.tipo})`
                };
            });
        },
    },
    methods: {
        mostrarDatos(lista){
            this.dialogParticipantes = true;
            this.listaParticipantes = lista;
        },
        fechasFiltros() {
            var today = new Date();
            var primerDia = new Date(today.getFullYear(), today.getMonth(), 1);
            var ultimoDia = new Date(today.getFullYear(), today.getMonth() + 1, 0);

            this.form.dateStart = this.formatDate(primerDia);
            this.form.dateEnd = this.formatDate(ultimoDia);
        },
        formatDate(date) {
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, '0');
            var day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        filteredConvocados() {
            if (!this.form.campana || !this.selectedMeetingType) {
                return []; // No se ha seleccionado ninguna campaña o tipo de reunión
            }
            return this.getFilteredConvocados(this.form.campana, this.selectedMeetingType);
        },
        async fetchInternos() {
            try {
                const response = await this.$axios.get('getInternos');
                this.internos = response.data.all;
            } catch (error) {
                console.error('Error al obtener los internos:', error);
            }
        },
        async fetchClients() {
            try {
                const response = await this.$axios.get('getClients');
                this.clientes = response.data.all;
            } catch (error) {
                console.error('Error al obtener los clientes:', error);
            }
        },
        getFilteredConvocados(campanaId, meetingType) {
            if (!campanaId) {
                return [];
            }
            const campanaIdNum = Number(campanaId);
            // Filtrar internos por campaña seleccionada
            let internosFiltrados = this.internos.filter(interno =>
                interno.campanas.some(campana => campana.in_CampanaId === campanaIdNum)
            ).map(interno => ({
                ...interno,
                tipo: 'interno'
            }));

            // Filtrar clientes por campaña seleccionada
            let clientesFiltrados = this.clientes.filter(cliente =>
                cliente.campanas.some(campana => campana.in_CampanaId === campanaIdNum)
            ).map(cliente => ({
                ...cliente,
                tipo: 'cliente'
            }));

            if (meetingType === 'interno') {
                // Si el tipo de reunión es 'interno', devolver solo los internos filtrados por campaña
                return internosFiltrados;
            } else if (meetingType === 'cliente') {
                // Si el tipo de reunión es 'cliente', devolver internos y clientes filtrados por campaña
                return [...internosFiltrados, ...clientesFiltrados];
            }

            // Si el tipo de reunión no es 'interno' ni 'cliente', devolver internos y clientes filtrados por campaña
            return [...internosFiltrados, ...clientesFiltrados];
        },
        limpiar() {
            this.form = {
                campana: null,
                centro: null,
                segmento: null,
                pais: null,
                dateStart: null,
                dateEnd: null,
                selectedAttendee: null,
                export: false
            }
        },
        getNameByid(id) {
            var data = '';
            data = this.internos.filter(item => item.id == id);
            if (data.length == 0) {
                data = this.clientes.filter(item => item.id == id);
            }

            if (data.length == 0) {
                return '';
            }

            return data[0].vc_Nombres + " " + data[0].vc_ApePaterno + " " + data[0].vc_ApeMaterno;

        },
        async createEvent(reset) {
            this.loadingMinutas = false;
            this.loadingBtnFilter = true;
            this.form.selectedAttendee = this.selectedAttendee;
            try {
                const response = await this.$axios.post('/reporte/minutas', this.form);
                if(response.data.data.length == 0){
                    this.$toast.info('Sin datos', {
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });
                }
                this.minutas = response.data.data;
            } catch (error) {
                console.log('Hubo un error en los datos');
            }
            this.loadingBtnFilter = false;
        },
       async exportar() {
            this.form.export = true;
            this.loadingBtnExport = true;
            this.form.selectedAttendee = this.selectedAttendee;
            
            if(this.form.dateStart == null || this.form.dateEnd == null){
                this.$toast.warning('seleccione un rango de fechas', {
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });

                this.form.export = false;
                this.loadingBtnExport = false;
                return false;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Minutas');
            
            const headerStyle = {
                fill: {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FF008000' }, 
                },
                font: {
                  color: { argb: 'FFFFFFFF' },
                  bold: true,
                },
                alignment: {
                  horizontal: 'center',
                },
                border: {
                    top: { style: 'thin', color: { argb: 'FF000000' } }, 
                    left: { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: { style: 'thin', color: { argb: 'FF000000' } },
                    right: { style: 'thin', color: { argb: 'FF000000' } },
                }
              };

            worksheet.columns = this.headerMinuta.map(header => ({
                header: header.text,
                key: header.value,
                width: 20, 
            }));

            const headerRow = worksheet.getRow(1);
            headerRow.eachCell((cell) => {
                cell.style = headerStyle;
            });
            
            const modifiedItems = this.minutas.map(item => {
                return {
                  ...item,
                  campana: item.campana.join(",\n"),
                  participantes: item.participantes.join(",\n"),
                  centro: item.centro.join(",\n"),
                  pais: item.pais.join(",\n"),
                  segmento: item.segmento.join(",\n"),
                };
              });

              modifiedItems.forEach(item => {
                const row = worksheet.addRow(item);
                row.eachCell((cell) => {
                    cell.style = {
                        alignment: {
                            horizontal: 'center',
                            vertical: 'middle',
                            wrapText: true, 
                        },
                        border: {
                            top: { style: 'thin', color: { argb: 'FF000000' } },
                            left: { style: 'thin', color: { argb: 'FF000000' } },
                            bottom: { style: 'thin', color: { argb: 'FF000000' } },
                            right: { style: 'thin', color: { argb: 'FF000000' } }, 
                        }
                    };
                })
            });

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), 'minutas.xlsx');

            this.form.export = false;
            this.loadingBtnExport = false;
        },
        changePais(){
            this.form.campana = null;
            this.form.centro = null;
            this.form.segmento = null;
            this.form.selectedAttendee = null;
        },
        changeCentro(){
            this.form.campana = null;
            this.form.segmento = null;
            this.form.selectedAttendee = null;
        },
        changeSegmento(){
            this.form.campana = null;
            this.form.selectedAttendee = null;
        },
        changeCampana(){
            this.form.selectedAttendee = null;
        },
        styleheader(){
            return {
                backgroundColor: '#008000'
            }
        },
    },
}


export default reporte;